import React from "react";
import { graphql } from "gatsby";
import GraphQLErrorList from "../components/Blog/graphql-error-list";
import Layout from "../components/Layout";
import SearchEngineOptimization from "../components/SEO";
import Position from "../components/Blog/Position";

export const query = graphql`
  query PositionTemplateQuery($id: String!) {
    post: sanityPosition(id: { eq: $id }) {
      id
      publishedAt
      title
      slug {
        current
      }
      seoTitle
      metaDescription
      textBlocks {
        blockTitle
        _rawBlockText(resolveReferences: { maxDepth: 5 })
      }
    }
    site {
      siteMetadata {
        siteUrl
      }
    }
  }
`;

const PositionTemplate = (props) => {
  const { data, errors } = props;
  const post = data && data.post;
  const site = data && data.site;
  return (
    <Layout>
      {errors && <SearchEngineOptimization title="GraphQL Error" />}
      {post && (
        <SearchEngineOptimization
          title={post.seoTitle}
          description={post.metaDescription}
          // openGraphImage={post.featuredImage.asset.url}
          // twitterOpenGraphImage={post.featuredImage.asset.url}
        />
      )}

      {errors && (
        <div className="container">
          <GraphQLErrorList errors={errors} />
        </div>
      )}

      {post && (
        <>
          <Position {...post} {...site} {...props.pageContext} />
        </>
      )}
    </Layout>
  );
};

export default PositionTemplate;
